function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViftoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "88px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fe650a",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M 7.5,19.5 C 14.5,19.5 21.5,19.5 28.5,19.5C 33.985,32.4742 39.485,45.4742 45,58.5C 52.7821,39.8166 60.9488,21.3166 69.5,3C 109.832,2.50001 150.165,2.33334 190.5,2.5C 190.334,6.84611 190.501,11.1794 191,15.5C 206.552,1.12326 224.385,-2.37674 244.5,5C 264.242,15.3179 272.075,31.4846 268,53.5C 261.171,74.0935 246.838,84.4269 225,84.5C 200.239,84.0663 185.572,71.733 181,47.5C 179.831,37.0107 182.331,27.5107 188.5,19C 180.841,18.5003 173.174,18.3336 165.5,18.5C 165.5,40.1667 165.5,61.8333 165.5,83.5C 158.833,83.5 152.167,83.5 145.5,83.5C 145.5,61.8333 145.5,40.1667 145.5,18.5C 141.833,18.5 138.167,18.5 134.5,18.5C 134.666,14.1539 134.499,9.82056 134,5.5C 132.296,9.74057 130.462,13.9072 128.5,18C 124.514,18.4988 120.514,18.6655 116.5,18.5C 116.5,25.1667 116.5,31.8333 116.5,38.5C 123.5,38.5 130.5,38.5 137.5,38.5C 135.8,43.7657 133.8,48.9324 131.5,54C 126.511,54.4993 121.511,54.6659 116.5,54.5C 116.5,64.1667 116.5,73.8333 116.5,83.5C 103.5,83.5 90.5,83.5 77.5,83.5C 77.6666,65.8302 77.4999,48.1635 77,30.5C 68.9301,47.9676 61.4301,65.6343 54.5,83.5C 47.8002,83.83 41.1335,83.4967 34.5,82.5C 25.2122,61.5946 16.2122,40.5946 7.5,19.5 Z M 218.5,18.5 C 236.92,16.6859 247.254,24.8526 249.5,43C 247.27,61.2967 236.937,69.2967 218.5,67C 202.325,60.1789 197.158,48.3456 203,31.5C 206.818,25.5123 211.984,21.179 218.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1e87e5",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M 28.5,19.5 C 21.5,19.5 14.5,19.5 7.5,19.5C 6.59603,18.791 6.26269,17.791 6.5,16.5C 13.5316,16.1697 20.5316,16.503 27.5,17.5C 27.8627,18.1835 28.1961,18.8501 28.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1e87e5",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M 269.5,69.5 C 276.703,69.8632 279.536,73.5299 278,80.5C 275.487,84.2115 271.987,85.3782 267.5,84C 262.081,80.581 261.415,76.4143 265.5,71.5C 267.026,71.0057 268.359,70.339 269.5,69.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViftoLogo);
export default __webpack_public_path__ + "static/media/vifto-logo.b8e580f8d210034a946f80214d4cc9fc.svg";
export { ForwardRef as ReactComponent };